import { useMemo } from 'react';

import { HtmlToJsxParserStyleParamsType } from './parser/types/HtmlToJsxParserStyleParamsType';
import { htmlToJsxParser } from './parser/htmlToJsxParser';

type ParsedHtmlContentProps = {
  htmlContent: string;
  styling?: HtmlToJsxParserStyleParamsType;
};

export const ParsedHtmlContent = ({ htmlContent, styling }: ParsedHtmlContentProps) => {
  const renderedContent = useMemo(() => {
    if (!htmlContent) return '';
    return <>{htmlToJsxParser(htmlContent, styling)}</>;
  }, [htmlContent, styling]);

  return renderedContent;
};
